export const links = [
  { id: '0', to: '#home', title: 'Home' },
  { id: '1', to: '#about', title: 'About' },
  { id: '2', to: '#services', title: 'Services' },
  { id: '3', to: '#portfolio', title: 'Portfolio' },
  { id: '4', to: '#blog', title: 'Blog' },
  { id: '5', to: '#contact', title: 'Contact' }];

export default 'NavbarData';
